<template>
    <v-card v-if="contact">
        <v-card-title class="text--white80 pa-0 pt-2 contact-page-title">
            <v-btn icon class="text--white80 px-6" @click="goBack">
                <v-icon large left class="text--white80">mdi-arrow-u-left-top</v-icon>
            </v-btn>
            <span class="title font-weight-light">Edit a sailor friend</span>
        </v-card-title>
        <v-form ref="contactForm"
                class="backgroundWhite35 pa-3 contact-form-compact"
                v-model="valid"
                lazy-validation>
            <v-text-field v-model="contact.name"
                      dense
                      :counter="30"
                      :rules="nameRules"
                          label="Name"
                          color="white"
                          class="text-input-white"
                          required></v-text-field>
            <v-text-field v-model="contact.email"
                          dense
                          :rules="emailRules"
                          class="text-input-white"
                          label="E-mail"
                          color="white"
                          required></v-text-field>
            <v-container fluid class="contact-phone-container">
                <v-row class="contact-phone-row">
                    <v-col cols="12" class="contact-phone-column">
                        <div class="d-flex flex-column">
                            <div>
                                <div class="text-matching-input-label">
                                    Phone number
                                </div>
                                <vue-tel-input class="tel-input--blue" v-model="contact.phoneNumber" v-bind="vueTel.props" @validate="phoneObject"></vue-tel-input>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
            <v-row class="justify-center contact-notification-section">
                <span class="white--text font-weight-bold pa-4">Notification Options</span>
                <v-expansion-panels>
                    <v-expansion-panel>
                        <v-expansion-panel-header expand-icon="mdi-email">
                            E-mail Notifications
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-row justify="space-between" class="align-start notification-checkbox-grid">
                                <v-flex xs6>
                                    <v-col cols="12">
                                        <span class="caption notification-group-caption" style="font-style: italic;">The following notifications will be sent in 'Armed' state.</span>
                                        <v-checkbox v-model="contact.gatewayPowerlossEmailActive" label="GTW Power Loss" prepend-icon="mdi-power-plug-off" class="py-0 my-0 pt-4" />
                                        <v-checkbox v-model="contact.shorePowerEmailActive" label="Shore Power" prepend-icon="mdi-meter-electric" class="py-0 my-0" />
                                        <v-checkbox v-model="contact.smartplugEmailActive" label="Smart Plug" prepend-icon="mdi-power-plug" class="py-0 my-0" />
                                        <v-checkbox v-model="contact.mainDoorEmailActive" label="Main Door" prepend-icon="mdi-door" class="py-0 my-0" />
                                        <v-checkbox v-model="contact.hatchEmailActive" label="Hatch Door" prepend-icon="mdi-door" class="py-0 my-0" />
                                        <v-checkbox v-model="contact.geofenceEmailActive" label="Geofence" prepend-icon="mdi-map-marker-radius" class="py-0 my-0" />
                                    </v-col>
                                </v-flex>
                                <v-divider vertical inset style="margin-top: 15px; margin-bottom: 30px;"></v-divider>
                                <v-flex xs6>
                                    <v-col cols="12">
                                        <span class="caption notification-group-caption" style="font-style: italic;">The following notifications will be sent in any state.</span>
                                        <v-checkbox v-model="contact.gatewayTamperedEmailActive" label="GTW Tampered" prepend-icon="mdi-domino-mask" class="py-0 my-0 pt-4" />
                                        <v-checkbox v-model="contact.detectorsEmailActive" label="Detectors" prepend-icon="mdi-security" class="py-0 my-0" />
                                        <v-checkbox v-model="contact.voltageLowEmailActive" label="Low Voltage" prepend-icon="mdi-sail-boat" class="py-0 my-0" />
                                        <v-checkbox v-model="contact.lowBatterySensorEmailActive" label="Low Battery" prepend-icon="mdi-access-point" class="py-0 my-0" />
                                    </v-col>
                                </v-flex>
                            </v-row>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel>
                        <v-expansion-panel-header expand-icon="mdi-message-text">
                            SMS Notifications
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-row justify="space-between" class="align-start notification-checkbox-grid">
                                <v-flex xs6>
                                    <v-col cols="12">
                                        <span class="caption notification-group-caption" style="font-style: italic;">The following notifications will be sent in 'Armed' state.</span>
                                        <v-checkbox v-model="contact.gatewayPowerlossSMSActive" label="GTW Power Loss" prepend-icon="mdi-power-plug-off" class="py-0 my-0 pt-4" />
                                        <v-checkbox v-model="contact.shorePowerSMSActive" label="Shore Power" prepend-icon="mdi-meter-electric" class="py-0 my-0" />
                                        <v-checkbox v-model="contact.smartPlugSMSActive" label="Smart Plug" prepend-icon="mdi-power-plug" class="py-0 my-0" />
                                        <v-checkbox v-model="contact.mainDoorSMSActive" label="Main Door" prepend-icon="mdi-door" class="py-0 my-0" />
                                        <v-checkbox v-model="contact.hatchSMSActive" label="Hatch Door" prepend-icon="mdi-calendar-minus" class="py-0 my-0" />
                                        <v-checkbox v-model="contact.geofenceSMSActive" label="Geofence" prepend-icon="mdi-map-marker-radius" class="py-0 my-0" />
                                    </v-col>
                                </v-flex>
                                <v-divider vertical inset style="margin-top: 15px; margin-bottom: 30px;"></v-divider>
                                <v-flex xs6>
                                    <v-col cols="12">
                                        <span class="caption notification-group-caption" style="font-style: italic;">The following notifications will be sent in any state.</span>
                                        <v-checkbox v-model="contact.gatewayTamperedSMSActive" label="GTW Tampered" prepend-icon="mdi-domino-mask" class="py-0 my-0 pt-4" />
                                        <v-checkbox v-model="contact.detectorsSMSActive" label="Detectors" prepend-icon="mdi-security" class="py-0 my-0" />
                                        <v-checkbox v-model="contact.voltageLowSMSActive" label="Low Voltage" prepend-icon="mdi-sail-boat" class="py-0 my-0" />
                                        <v-checkbox v-model="contact.lowBatterySensorSMSActive" label="Low Battery" prepend-icon="mdi-access-point" class="py-0 my-0" />
                                    </v-col>
                                </v-flex>
                            </v-row>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-row>
            <v-row>
                <v-col class="text-left">
                    <v-btn :disabled="!valid"
                           color="error"
                           @click="initRemove">
                        DELETE
                        <v-icon right>
                            mdi-delete
                        </v-icon>
                    </v-btn>
                </v-col>
                <v-col class="text-right">
                    <v-btn :disabled="!valid || !isValid"
                           color="primary"
                           @click="initSave">
                        <v-icon left>
                            mdi-check
                        </v-icon>
                        SAVE
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>

        <ConfirmDialog v-model="showConfirm"
                       title="Confirm"
                       message="Do you want to remove the contact ?"
                       @OnOk="confirmOk" />
        <ConfirmDialog v-model="showSuccess"
                       :options="{ noconfirm: true }"
                       title="Success"
                       message="Changes saved successfully."
                       @OnOk="successOk" />

        <ConfirmDialog v-model="showLeaveConfirm"
                       :options="{ persistent: true }"
                       title="Unsaved Changes"
                       message="You have unsaved changes. Do you really want to leave without saving?"
                       @OnOk="leaveWithoutSaving" />
        <ConfirmDialog v-model="showStatus"
                       :options="{ noconfirm: true }"
                       :title="statusTitle"
                       :message="statusMessage" />
    </v-card>
</template>

<script lang="ts">
import { defineComponent, ref, getCurrentInstance } from "vue";
import useContact from "@/store/useContact";
import ContactViewModel from "@/models/ContactViewModel";
import { VueTelInput } from "vue-tel-input";

export default defineComponent({
    components: {
        VueTelInput,
        ConfirmDialog: () =>
            import(/* webpackChunkName: "settings" */ "./components/Dialogs/ConfirmDialog.vue")
    },
    setup() {
        const root = getCurrentInstance()?.proxy as any;
        const { update, get, remove, nameRules, emailRules } = useContact();
        const contactForm = ref<HTMLFormElement>();
        const contact = ref<ContactViewModel>();
        const originalContact = ref<ContactViewModel>();
        const id = parseInt(root.$route.params.id);
        const valid = ref<boolean>(true);
        const showConfirm = ref<boolean>(false);
        const showSuccess = ref<boolean>(false);
        const showLeaveConfirm = ref<boolean>(false);
        const allowLeave = ref<boolean>(false);
        const showStatus = ref<boolean>(false);
        const statusTitle = ref<string>("Update failed");
        const statusMessage = ref<string>("Please try again.");
        const pendingRoute = ref<null | ((allow?: boolean) => void)>(null);

        const hasUnsavedChanges = () =>
            contact.value && originalContact.value
                ? !root.$_.isEqual(contact.value, originalContact.value)
                : false;

        const setPendingRoute = (next) => {
            pendingRoute.value = next;
        };

        const goBack = () => {
            if (hasUnsavedChanges()) {
                pendingRoute.value = null;
                showLeaveConfirm.value = true;
            } else {
                window.history.back();
            }
        };

        const leaveWithoutSaving = () => {
            allowLeave.value = true;
            if (pendingRoute.value) {
                const next = pendingRoute.value;
                pendingRoute.value = null;
                next();
            } else {
                window.history.back();
            }
        };

        const successOk = () => {
        };

        const handleStatus = (status: number) => {
            if (status === 200) {
                return true;
            }

            if (status === 403) {
                statusTitle.value = "Not allowed";
                statusMessage.value = "Only the captain can change contacts for this device.";
            } else if (status === 409) {
                statusTitle.value = "Duplicate email";
                statusMessage.value = "This email already exists for this device or belongs to a captain.";
            } else if (status === 404) {
                statusTitle.value = "Not found";
                statusMessage.value = "This contact no longer exists.";
            } else {
                statusTitle.value = "Update failed";
                statusMessage.value = "Please try again.";
            }

            showStatus.value = true;
            return false;
        };

        const initSave = () => {
            if (contactForm.value) {
                valid.value = contactForm.value.validate();
                if (valid.value && contact.value) {
                    update(contact.value).then((status) => {
                        if (handleStatus(status)) {
                            originalContact.value = root.$_.cloneDeep(contact.value);
                            showSuccess.value = true;
                        }
                    });
                }
            }
        };

        const vueTel = {
            phone: "",
            props: {
                autoFormat: true,
                autoDefaultCountry: true,
                dropdownOptions: {
                    showDialCodeInList: true,
                    showDialCodeInSelection: false,
                    showFlags: true,
                    showSearchBox: true,
                    width: '300px',
                },
                ignoredCountries: ["KP", "RU"],
                inputOptions: {
                    autocomplete: 'on',
                    showDialCode: true,
                    placeholder: 'Enter phone number',
                    required: true,
                },
                mode: "international",
                preferredCountries: ["DK", "NO", "SE"],
                validCharactersOnly: true,
            }
        };

        const initRemove = () => {
            showConfirm.value = true;
        };

        const confirmOk = () => {
            remove(id).then((status) => {
                if (handleStatus(status)) {
                    window.history.back();
                }
            });
        };

        get(id).then((model: ContactViewModel) => {
            contact.value = model;
            originalContact.value = root.$_.cloneDeep(model);
        });

        return {
            contactForm,
            valid,
            contact,
            nameRules,
            emailRules,
            initRemove,
            initSave,
            confirmOk,
            successOk,
            showConfirm,
            showSuccess,
            goBack,
            vueTel,
            showLeaveConfirm,
            leaveWithoutSaving,
            hasUnsavedChanges,
            setPendingRoute,
            allowLeave,
            showStatus,
            statusTitle,
            statusMessage,
        };
    },
    beforeRouteLeave(to, from, next) {
        if (this.allowLeave) {
            this.allowLeave = false;
            next();
            return;
        }
        if (this.hasUnsavedChanges && this.hasUnsavedChanges()) {
            this.setPendingRoute(next);
            this.showLeaveConfirm = true;
        } else {
            next();
        }
    },
    data: () => ({
        isValid: false,
    }),
    methods: {
        phoneObject: function (object) {
            this.isValid = object.valid === true;
        },
    }
});
</script>

<style scoped lang="scss">
    .contact-page-title {
        min-height: 48px;
    }

    .contact-form-compact {
        padding-top: 8px !important;
    }

    .contact-phone-container {
        padding: 0;
    }

    .contact-phone-row {
        margin: 0;
    }

    .contact-phone-column {
        padding: 4px 0 8px;
    }

    .contact-notification-section {
        margin: 0;
    }

    .contact-notification-section > span {
        padding: 8px 0;
    }

    .contact-form-compact ::v-deep .v-text-field {
        margin-top: 4px;
        padding-top: 4px;
    }

    .contact-form-compact ::v-deep .v-expansion-panel-header {
        min-height: 48px;
        padding: 0 12px;
        font-size: var(--app-font-body);
    }

    .contact-form-compact ::v-deep .v-expansion-panel-content__wrap {
        padding: 0 8px 8px;
    }

    .contact-form-compact ::v-deep .v-input--checkbox {
        margin-top: 0;
        padding-top: 0;
    }

    .contact-form-compact ::v-deep .v-input--checkbox .v-input__slot {
        min-height: 32px;
        margin-bottom: 0;
        align-items: center !important;
    }

    .contact-form-compact ::v-deep .v-input--checkbox .v-label {
        font-size: var(--app-font-compact);
        line-height: 1rem;
    }

    .contact-form-compact ::v-deep .v-input--checkbox .v-input__prepend-outer {
        margin-right: 4px;
    }

    .contact-form-compact ::v-deep .v-input--checkbox .v-input--selection-controls__input {
        margin-right: 4px;
    }

    .contact-form-compact ::v-deep .v-flex > .col {
        padding: 8px;
    }

    @media (max-width: 600px) {
        .contact-form-compact ::v-deep .v-input--checkbox .v-input__prepend-outer {
            display: none;
        }
    }

    .v-card ::v-deep .text-input-white .v-text-field__slot input {
        color: #fff !important;
    }

    ::v-deep .v-input .v-input__control .v-input__slot {
        align-items: start;
    }

    .text-matching-input-label {
        font-size: var(--app-font-small) !important;
        color: #0009 !important;
    }
</style>